import { DateBadgeIcon, DateBadgeIcons } from 'modules/Tasks/DateBadge/DateBadge.interface';
import { TaskPriorities } from 'modules/Tasks/types';

/**
 * Maps a priority to its DateBadge icon. Two levels only: HIGH shows the red exclamation;
 * NORMAL shows nothing. Takes a plain priority number so both tasks (`task.priority`) and groups
 * (`group.priority`, once populated) share one rule.
 */
export default function priorityToDateBadgeIcon(priority: number): DateBadgeIcon | undefined {
    return priority >= TaskPriorities.HIGH ? DateBadgeIcons.URGENT : undefined;
}
